import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Avatar from '../Avatar';
import { toLowerCase } from '../../helpers/string';
import { SUBSCRIPTION_STATE, GUEST_PASS_LABEL } from '../../utils/constants';

const UserProfileItem = ({
  userInfo: {
    firstName,
    lastName,
    role,
    subscriptionState,
    subscriptionType,
    avatar,
  },
  isDesktop,
}) => (
  <div className="user-profile__item">
    {!isDesktop && <Avatar image={avatar} />}
    <div className="user-profile__item__detail">
      <div className="user-profile__item__detail__name">
        {firstName} {lastName}
        {subscriptionState && (
          <span
            className={classNames(
              'subscription-state',
              toLowerCase(subscriptionState),
            )}
          >
            {subscriptionState}
          </span>
        )}
      </div>
      <div className="user-profile__item__detail__subscription">
        {role === 'SELECT' && <i className="fas fa-star" />}
        {subscriptionState === SUBSCRIPTION_STATE.expired ? (
          <p>
            {GUEST_PASS_LABEL.split(' ')[0]}{' '}
            <span className="lowerCase">{GUEST_PASS_LABEL.split(' ')[1]}</span>
          </p>
        ) : (
          toLowerCase(subscriptionType)
        )}{' '}
        {role === 'SELECT' && '/ Select Member'}
      </div>
    </div>
  </div>
);

UserProfileItem.defaultProps = {
  userInfo: {
    firstName: '',
    lastName: '',
    role: '',
    subscriptionState: '',
    subscriptionType: '',
    avatar: null,
  },
  isDesktop: false,
};

UserProfileItem.propTypes = {
  userInfo: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    role: PropTypes.string,
    subscriptionState: PropTypes.string,
    subscriptionType: PropTypes.string,
    avatar: PropTypes.string,
  }),
  isDesktop: PropTypes.bool,
};

export default UserProfileItem;
